import { action, computed, makeAutoObservable } from 'mobx'
import { Store } from '@stores'

export class JobBatchesStore {
  _store: Store
  loading: boolean
  job_batch: any | null

  constructor(store: Store) {
    makeAutoObservable(this)
    this._store = store
    this.loading = false
    this.job_batch = null
  }

  @computed
  get is_loading() {
    return this.loading
  }

  @computed
  get watch_job_batch() {
    return this.job_batch
  }

  @action
  async getJobBatch(id: string | number) {
    this.loading = true
    try {
      const res = await this._store.api.jobs.get_job_batch_single(id)
      this.job_batch = res
      return res
    } finally {
      this.loading = false
    }
  }
}
